// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".shop_promise_pdp." + __webpack_require__.h() + ".js";
};